import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"

import Field from "../AddUsers/AddPeopleCSV/Field"
import {RecapContainer, List} from "../AddUsers/AddPeopleCSV/styled"

interface Props {
  assignMembers?: boolean
}
const FieldsRecap: React.FC<Props> = ({assignMembers}) => (
  <RecapContainer>
    <H4>
      <FormattedMessage id="admin.components.addPeopleCSV.fieldsMapping.title" />
    </H4>
    <List>
      {assignMembers ? (
        <Field
          label="admin.components.addPeopleCSV.fieldsMapping.email.label"
          description="admin.components.addPeopleCSV.fieldsMapping.email.description"
        />
      ) : (
        <>
          <Field
            label="admin.components.addPeopleCSV.fieldsMapping.email.label"
            description="admin.components.addPeopleCSV.fieldsMapping.email.description"
          />
          <Field
            label="admin.components.addPeopleCSV.fieldsMapping.team.label"
            description="admin.components.assignManagersCSV.fieldsMapping.team.description"
          />
        </>
      )}
    </List>
  </RecapContainer>
)

export default FieldsRecap
